import React, { useState, useEffect } from "react";
import CardRelease from "./CardRelease";
import CardCategories from "./CardCategories";
import { Grid, Container, Typography } from "@mui/material";
import axios from "axios";
import config from "../config";

export default function NewRelease() {
  const [productList, setProductList] = useState([]);
  useEffect(() => {
    axios
      .get(
        `${config.url}/products?sort=desc&sortBy=created_at&limit=3`,
        config.token
      )
      .then((res) => {
        setProductList(res.data.data);
      });
  }, []);
  return (
    <Container maxWidth="xl">
      <Typography color={"#5a5a56"}>
        <h3>Newest Release</h3>
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{
          display: {
            xs: "none",
            sm: "none",
            lg: "flex",
          },
        }}
      >
        {productList?.map((data, index) => (
          <Grid item xs={12} md={4} lg={4} key={index}>
            <CardRelease data={data} />
          </Grid>
        ))}
      </Grid>
      <Grid
        container
        direction="row"
        sx={{
          display: {
            xs: "flex",
            sm: "none",
            lg: "none",
          },
          alignItems: "center",
        }}
      >
        {/* <SwipeableViews
          style={styles.root}
          slideStyle={styles.slideContainer}
          enableMouseEvents
        > */}
        {productList?.map((data, index) => (
          <Grid item xs={4} md={4} key={index}>
            <CardCategories data={data} type="release" />
          </Grid>
        ))}
        {/* </SwipeableViews> */}
      </Grid>
    </Container>
  );
}
